
import { AuthService } from './../../../services/auth.service';
import { SearchService } from 'src/app/services/search.service';
import { HeaderService } from './../../../services/header.service';
import { Component, OnInit } from '@angular/core';
import { NotificationModel } from 'src/app/models/Notifications/NotificationModel'
import { NotificationStatusEnum } from 'src/app/models/enums/Notification/NotificationStatusEnum'
@Component({
  selector: 'app-my-notifications',
  templateUrl: './my-notifications.component.html',
  styleUrls: ['./my-notifications.component.css']
})
export class MyNotificationsComponent implements OnInit {

  notifications;
  notificationsList: NotificationModel[] = [];
  totalCount;
  pageSize: number;
  page = 1;
  customer;

  constructor(private service: HeaderService,
    private searchService: SearchService,
    private authService: AuthService
  ) {

  }

  ngOnInit() {
    this.pageSize = this.searchService.notificationsPageSize;

    this.authService.loggedInUser.subscribe(res => {
      if (res != null) {
        this.customer = res;
        this.searchService.getUserNotificationsResult(res.customerModel.customerID, this.page, this.pageSize).subscribe(res => {

          this.totalCount = res.totalCount;
          let _notifications = [];

          res.items.forEach(element => {
            let notification: NotificationModel = {
              title: element.message,
              date: element.createdOn.toString(),
              internalNotificationID: element.internalNotificationID,
              notificationTemplateDefinitionID: element.notificationTemplateDefinitionID,
              text: ""
            }
            this.notificationsList.push(notification);
          });
        })
      }
    })

  }

  deleteRow(notification: NotificationModel) {
    this.searchService.updateNotificationStatus(notification.internalNotificationID, NotificationStatusEnum.Deleted)
      .subscribe(res => {

        if (res != null) {
          const index = this.notificationsList.indexOf(notification, 0);
          if (index > -1) {
            this.notificationsList.splice(index, 1);
          }
        }
      })

  }

  deleteAll() {
    this.searchService.deleteAllNotifications(this.customer.customerModel.customerID).subscribe(res => {
      if (res != null) {
        this.notificationsList = [];
        this.totalCount = 0;
      }
    })

  }
  onScroll() {


    this.page++;
    if (this.page <= Math.ceil(this.totalCount / this.pageSize)) {

      if (this.customer != null) {
        this.searchService.getUserNotificationsResult(this.customer.customerModel.customerID, this.page, this.pageSize).subscribe(res => {
          res.items.forEach(element => {
            let notification: NotificationModel = {
              title: element.message,
              date: element.createdOn.toString(),
              internalNotificationID: element.internalNotificationID,
              notificationTemplateDefinitionID: element.notificationTemplateDefinitionID,
              text: ""
            }
            this.notificationsList.push(notification);
          });
        })
      }
    }



  }


}
